import { HardwareSku } from "src/api/types.generated";

type THardwareRequestSearchable = {
  id: number;
  user?: { name?: string | null } | null;
  hardware_item_requests?: Array<{
    HardwareItem?: { sku_code: string } | null;
  }> | null;
};

export const filterHardwareRequestsBySearch = <
  T extends THardwareRequestSearchable
>(
  requests: T[] | undefined,
  query: string | undefined,
  items: Pick<HardwareSku, "code" | "name" | "description">[]
): T[] | undefined => {
  const trimmedQuery = query?.trim().toLowerCase();
  if (!trimmedQuery) return requests;

  return requests?.filter((request) => {
    if (request.user?.name?.toLowerCase().includes(trimmedQuery)) {
      return true;
    }

    if (
      String(request.id).includes(trimmedQuery) ||
      `request #${request.id}`.toLowerCase().includes(trimmedQuery)
    ) {
      return true;
    }

    return (
      request.hardware_item_requests?.some((itemRequest) => {
        if (!itemRequest.HardwareItem) return false;
        const skuInfo = items.find(
          (item) => item.code === itemRequest.HardwareItem?.sku_code
        );
        return (
          !!skuInfo &&
          (skuInfo.name.toLowerCase().includes(trimmedQuery) ||
            skuInfo.description.toLowerCase().includes(trimmedQuery))
        );
      }) ?? false
    );
  });
};
